import React from 'react';

const TodoContext = React.createContext(null);

export default TodoContext;
